<template>
    <Page class="view-library-flows">
        <div ref="scroller" class="scroller" @scroll="handleScroll">

            <State 
                :isLoading="isLoading" 
                :isEmpty="isEmpty" 
                subject="flows">

                <v-infinite-scroll :items="limitedFlows" @load="handleLoad">

                    <div class="flow-list">
                        <FlowItem
                            v-for="(item, index) in limitedFlows"
                            :key="item.flow"
                            :item="item"
                            :lighter="index % 2 == 1" 
                            @select="handleSelect" />
                    </div>

                    <!--
                    <template v-slot:empty>
                        <span class="empty" style="">
                            No more flows available.
                        </span>
                    </template>
                    -->

                </v-infinite-scroll>

            </State>
            
        </div>

        <TransitionFadeY>
            <FloatingButton
                v-if="isScrolled" 
                style="padding-left: 0px !important; padding-right: 0px !important;"
                justify="right"
                tooltip="go back to the top"
                @click="handleUnscroll">
                <v-icon icon="fa-solid fa-caret-up"></v-icon>
            </FloatingButton>
        </TransitionFadeY>
    </Page>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { TransitionFadeY } from '@generio-ai/library-legacy/components/transitions'
import FloatingButton from '@/components/common/button/FloatingButton.vue'
import State from '@/components/common/state/State.vue'
import FlowItem from '@/components/library/flow/FlowItem.vue'
import Page from '@/components/library/page/Page.vue'

export default {
    name: 'ViewLibraryFlows',
    components: {
        TransitionFadeY,
        FloatingButton,
        State,
        FlowItem,
        Page
    },
    data() {
        return {
            count: 0,
            isScrolled: false
        }
    },
    computed: {
        ...mapGetters('assets', [
            'isSynchronized',
            'getAsset'
        ]),
        ...mapGetters('library', [
            'getFilteredAssetsByFlow'
        ]),
        isLoading() {
            return !this.isSynchronized
        },
        isEmpty() {
            return !Array.isArray(this.flows) || this.flows.length === 0
        },
        flows() {
            return this.getFilteredAssetsByFlow
        },
        limitedFlows() {
            return this.flows ? this.flows.slice(0, this.count + 1) : []
        },
        length() {
            return this.limitedFlows?.length
        }
    },
    methods: {
        ...mapActions('windows', [
            'open'
        ]),
        handleQuery() {
            const { id } = this.$route.query
            if (id === undefined || id === null) return
            if (this.isLoading) return
            const asset = this.getAsset(id)
            this.handleSelect(asset)
        },
        handleLoad({ done }) {
            if (this.count >= this.length) {
                done('empty')
                return
            }
            this.count++
            done('ok')

            const scroller = this.$refs.scroller
            if (scroller === undefined || scroller === null) return

            const scrollPosition = scroller.scrollTop
            this.isScrolled = scrollPosition > 100
        },
        handleScroll() {
            const scroller = this.$refs.scroller
            if (scroller === undefined || scroller === null) return

            const scrollPosition = scroller.scrollTop
            this.isScrolled = scrollPosition > 100
        },
        handleUnscroll() {
            this.$refs.scroller.scroll({
                top: 0,
                behavior: 'smooth'
            })
            this.isScrolled = false
        },
        handleSelect(asset) {
            this.open({ 
                component: "asset", 
                payload: { 
                    asset 
                } 
            })
        }
    },
    mounted() {
        this.handleQuery()
    }
}
</script>

<style>
.view-library-flows .v-infinite-scroll__side { 
    padding: 15px !important;
}
</style>

<style scoped>
.view-library-flows .scroller {
    display: block;
    height: 100%;
    width: 100%;
    overflow-y: auto;
}

.view-library-flows .empty {
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 1.3rem;
}

.flow-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
}

@media (max-width: 599.98px) {
    .flow-list {
        gap: 12px;
        padding: 12px;
    }
}
</style>
